"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _environment = _interopRequireDefault(require("../../utils/environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useServerEffect = function useServerEffect(callback, dependencies) {
  var mounted = (0, _react.useRef)(false);
  var prevDeps = (0, _react.useRef)(dependencies);
  if (!mounted.current) {
    mounted.current = true;
    callback();
  }
  if (_environment.default.isServer) {
    if (dependencies === undefined || !(0, _isEqual.default)(prevDeps.current, dependencies)) {
      prevDeps.current = dependencies;
      callback();
    }
  }
};
var _default = useServerEffect;
exports.default = _default;